import { Component, Input } from '@angular/core';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { ITableCellItem } from '../../../../../shared/shared/table/table-cell';
import { IDocumentDto, IRecipient_rolesDto } from '../../../dto/document-listing.dto';
import { setRecipientData } from 'app/global/get-recipient-data';
import { RecipientView } from 'app/main/shared/shared/table/models/recipient-view.model';
import { uniqueArray } from "../../../../../../global/unique-array";

@Component({
    selector: 'app-recipient-column',
    templateUrl: './recipient-column.component.html',
    styleUrl: './recipient-column.component.scss'
})
export class RecipientColumnComponent implements ITableCellItem {

    recipients: RecipientView[] = [];

    @Input() set dataItem(dataItem: IDocumentDto) {
        const recipientRoles = dataItem?.recipient_roles ?? [];

        this.recipients = uniqueArray<IRecipient_rolesDto>(recipientRoles, 'id')
            .map(role => this.mapRecipient(role))
            .filter((r): r is RecipientView => r !== null);
    }

    @Input() columnOptions: ITableColumn;

    private mapRecipient(role: IRecipient_rolesDto): RecipientView | null {
        const recipient = setRecipientData(role.personfields) as {
            firstname?: string;
            lastname?: string;
        };

        const firstname = recipient.firstname?.trim();
        const lastname = recipient.lastname?.trim();

        if (!firstname && !lastname) {
            return null;
        }

        return {
            name: `${firstname ?? ''} ${lastname ?? ''}`.trim(),
            isDeleted: Boolean(role?.recipient?.deleted_at)
        };
    }
}
